import React from 'react';

import FeedbackSection from '@/components/FeedbackSection';
import useSettingItem from '@/hooks/useSettingItem';
import useCurrentVacancy from '@/hooks/useCurrentVacancy';
import { PrepareVmValues } from '@/components/forms/DynamicContactsForm/types';
import { sendVacancyForm } from '@/services/requests';

import TopSection from './components/TopSection';
import GetSection from './components/GetSection';
import JobSection from './components/JobSection';

function Vacancy() {
  const vacancyResource = useCurrentVacancy();
  const vacancyData = vacancyResource?.data;
  const formVacancyTitle = useSettingItem('FORM_VACANCIES_TITLE', vacancyData?.language);

  const handleSendVacancyForm = async (
    values: PrepareVmValues
  ): Promise<void> => {
    try {
      await sendVacancyForm({
        id: Number(vacancyData?.id),
        fields: values,
      });
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <>
      <TopSection />
      <JobSection />
      <GetSection />
      {vacancyData?.formFields && (
        <FeedbackSection
          formTitle={formVacancyTitle}
          formText={vacancyData?.formText}
          idAnchor="contacts"
          isVacancy={{
            formFields: vacancyData.formFields,
            submitAsync: handleSendVacancyForm,
          }}
        />
      )}
    </>
  );
}

export default Vacancy;
